import React from 'react';
import {bike} from '../../assets/images/images'
import {Grid} from "@material-ui/core";

function Index(props) {
  return (
    <Grid container justify='center' alignItems='center' direction={"column"} className=' mt-80 p-main'>
      <h1 className='mb-0 mt-20'>Order placed successfully!</h1>
      <div className='full-width display-flex align-items-center flex-column justify-content-center'>
        <img src={bike} alt={'no product'} width='100%' height={300} style={{objectFit: 'contain'}}/>
        <caption className='black-color font-12'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
          tempor incididunt ut <br/> labore et dolore magna aliqua. Ut enim ad minim veniam
        </caption>
      </div>
      <div className='display-flex  flex-column align-items-center checkout-container mt-30 mb-20'>
        <button
          className=' add-cart-btn-small display-flex justify-content-center  bg-green border-none white-color text-center'
          style={{minWidth: 220}}
          onClick={() => props.history.push('/')}
        >
          CONTINUE SHOPPING
        </button>
      </div>
      {/*</div>*/}
    </Grid>
  );
}

export default Index;
